"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTextMedium(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm2.999 2.4427a.4264.4264 0 0 1 .4041-.4433h9.1939a.4264.4264 0 0 1 .4042.4433v2.11c0 .244-.122.443-.27.443s-.344-.183-.433-.406l-.35-.708a.6742.6742 0 0 0 -.567-.4056h-1.9072a.5655.5655 0 0 0 -.4728.5239v8c0 .244.242.872.455.942l1.162.279a.55.55 0 0 1 .3871.4533.3725.3725 0 0 1 -.4041.326h-5.2022a.3725.3725 0 0 1 -.4041-.326.55.55 0 0 1 .3871-.4533l1.141-.279c.213-.07.478-.698.478-.942v-8a.5875.5875 0 0 0 -.4951-.5235h-1.8859a.6744.6744 0 0 0 -.5669.4058l-.35.708c-.09.223-.285.406-.433.406s-.271-.199-.271-.443v-2.11' })));
}
exports.default = SvgTextMedium;
